import logoPath from "../../assets/white-green-logo.svg";

function Logo() {
  return <img src={logoPath} alt="Logo"  className='mx-auto mt-[10px]' />;
}

export default Logo;
